import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import './custom.scss';
import './styles/_theme.scss';
import store from './redux/store';
import './i18n';

const theme = process.env.REACT_APP_THEME_NAME || 'mathys';

const rootElement = document.getElementById('root');

rootElement.classList.add(`${theme}-theme`);

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
